import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Earnings from './Earnings';
import Due from './Due';

const Payments = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/payments/due" replace />} />
      <Route path="earnings" element={<Earnings />} />
      <Route path="due" element={<Due />} />
    </Routes>
  );
};

export default Payments;
